var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "resportesserie" },
    [
      _c(
        "div",
        { staticClass: "flex sm12 md12" },
        [
          _c(
            "FormFieldsContainer",
            [
              _c(
                "v-flex",
                { attrs: { sm16: "", md16: "", layout: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { sm16: "", md16: "", layout: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { attrs: { sm2: "", md2: "" } },
                        [
                          _c("DatePicker", {
                            attrs: {
                              label: _vm.formFields.fechaSolicitudInicio.label,
                              "error-messages": _vm.errors.collect(
                                _vm.formFields.fechaSolicitudInicio.id
                              ),
                              id: _vm.formFields.fechaSolicitudInicio.id,
                              max: _vm.fechaMaximaInicio.format("YYYY-MM-DD")
                            },
                            model: {
                              value: _vm.formFields.fechaSolicitudInicio.value,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.formFields.fechaSolicitudInicio,
                                  "value",
                                  $$v
                                )
                              },
                              expression:
                                "formFields.fechaSolicitudInicio.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { sm2: "", md2: "" } },
                        [
                          _c("DatePicker", {
                            attrs: {
                              label: _vm.formFields.fechaSolicitudFin.label,
                              "error-messages": _vm.errors.collect(
                                _vm.formFields.fechaSolicitudFin.id
                              ),
                              id: _vm.formFields.fechaSolicitudFin.id,
                              max: _vm.fechaMaximaInicio.format("YYYY-MM-DD")
                            },
                            model: {
                              value: _vm.formFields.fechaSolicitudFin.value,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.formFields.fechaSolicitudFin,
                                  "value",
                                  $$v
                                )
                              },
                              expression: "formFields.fechaSolicitudFin.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { sm2: "", md2: "" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              label: _vm.formFields.modulo.label,
                              items: _vm.moduloList,
                              "item-text": "configdescripcion",
                              "item-value": "configid",
                              clearable: "",
                              required: ""
                            },
                            model: {
                              value: _vm.formFields.modulo.value,
                              callback: function($$v) {
                                _vm.$set(_vm.formFields.modulo, "value", $$v)
                              },
                              expression: "formFields.modulo.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { sm2: "", md2: "" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              label: _vm.formFields.solicitante.label,
                              items: _vm.usuarioList,
                              "item-text": "nombre",
                              "item-value": "usuarioid_alta",
                              clearable: ""
                            },
                            model: {
                              value: _vm.formFields.solicitante.value,
                              callback: function($$v) {
                                _vm.$set(
                                  _vm.formFields.solicitante,
                                  "value",
                                  $$v
                                )
                              },
                              expression: "formFields.solicitante.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { sm2: "", md2: "" } },
                        [
                          _c("v-autocomplete", {
                            attrs: {
                              label: _vm.formFields.estado.label,
                              items: _vm.estadoList,
                              "item-text": "text",
                              "item-value": "value",
                              clearable: ""
                            },
                            model: {
                              value: _vm.formFields.estado.value,
                              callback: function($$v) {
                                _vm.$set(_vm.formFields.estado, "value", $$v)
                              },
                              expression: "formFields.estado.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { sm2: "", md2: "" } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              label: _vm.formFields.operacion.label,
                              clearable: ""
                            },
                            model: {
                              value: _vm.formFields.operacion.value,
                              callback: function($$v) {
                                _vm.$set(_vm.formFields.operacion, "value", $$v)
                              },
                              expression: "formFields.operacion.value"
                            }
                          })
                        ],
                        1
                      ),
                      _c(
                        "v-flex",
                        { attrs: { sm5: "", md5: "" } },
                        [
                          _c(
                            "v-btn",
                            { on: { click: _vm.handleBuscarClick } },
                            [
                              _c("v-icon", [_vm._v("search")]),
                              _vm._v("Filtrar\n            ")
                            ],
                            1
                          ),
                          _c(
                            "v-btn",
                            { on: { click: _vm.clearFilters } },
                            [
                              _c("v-icon", [_vm._v("clear")]),
                              _vm._v("Limpiar\n            ")
                            ],
                            1
                          ),
                          _c(
                            "v-btn",
                            {
                              attrs: { flat: "", small: "", color: "primary" },
                              on: { click: _vm.getCSV }
                            },
                            [
                              _c(
                                "v-icon",
                                { staticClass: "importExportBtnIcon" },
                                [_vm._v("cloud_download")]
                              ),
                              _vm._v("\n                \n              "),
                              _c(
                                "span",
                                { staticClass: "importExportBtnTexto" },
                                [_vm._v("Exportar"), _c("br"), _vm._v("CSV")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("div", {
                staticClass: "clearfix",
                staticStyle: { width: "100%" }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "gridcard rounded-card" },
        [
          _c("MantenedorGridSinCodigo", {
            attrs: {
              "grid-options": _vm.gridOptions,
              "funcionalidad-id": _vm.funcionalidad
            }
          })
        ],
        1
      ),
      _vm.mostrarModalVerDetalle
        ? _c("VerDetalleModal", {
            attrs: { params: _vm.params },
            on: { cerrar: _vm.handleCierreModalVerDetalle }
          })
        : _vm._e(),
      _vm.showPopUpReport
        ? _c("PopUpGeneratedReports", {
            attrs: { text: _vm.msgReport },
            on: { cerrar: _vm.handleCloseReport }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }